import classNames from 'classnames';

// styles
import s from './CollectionRouterPreloader.sss';

// types
type CollectionRouterPreloaderProps = {
  className?: string;
};

export const CollectionRouterPreloader: React.FC<CollectionRouterPreloaderProps> = ({
  className,
}) => (
  <div className={classNames(s.root, className)} />
);

export default CollectionRouterPreloader;
